import reducer from 'state/order/reducers';
import actions from 'state/order/actionCreators';
import types from 'state/order/actionTypes';
import selectors from 'state/order/selectors';
import selectorsByType from 'state/order/selectorsByType';
import actionsByType from 'state/order/actionsByType';
import sagasByType from 'state/order/sagasByType';
import effects from 'state/order/effects';

export {
  actions,
  effects,
  selectors,
  selectorsByType,
  actionsByType,
  sagasByType,
  types,
};

export default reducer;
